import { Typography } from "@material-ui/core";
import React from "react";

function Disclaimer(props) {
  return (
    <React.Fragment>
      <Typography paragraph variant="h5">
        Disclaimer
      </Typography>
      <Typography paragraph variant="body1">
        Updated at 2022-02-02
      </Typography>
      <Typography paragraph variant="body1">
        Invifo hereby grants you access to . ("the Website") and invites you to
        purchase the services offered here.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Definitions and key terms
      </Typography>
      <Typography paragraph variant="body1">
        To help explain things as clearly as possible in this Disclaimer, every
        time any of these terms are referenced, are strictly defined as:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            <b>Cookie</b>: small amount of data generated by a website and saved
            by your web browser. It is used to identify your browser, provide
            analytics, remember information about you such as your language
            preference or login information.
          </li>
          <li>
            <b>Company</b>: when this policy mentions "Company," "we," "us," or
            "our," it refers to Invifo Technology International, Level 11, One
            Pacific Place, Sudirman Central Business District, Kav 52 - 53,
            Jakarta Selatan 12190, Indonesia that is responsible for your
            information under this Privacy Policy.
          </li>
          <li>
            <b>Country</b>: where Invifo or the owners/founders of Invifo are
            based, in this case is Indonesia.
          </li>
          <li>
            <b>Customer</b>: refers to the company, organization or person that
            signs up to use the Invifo Service to manage the relationships with
            your consumers or service users.
          </li>
          <li>
            <b>Device</b>: any internet connected device such as a phone,
            tablet, computer or any other device that can be used to visit
            Invifo and use the services.
          </li>
          <li>
            <b>IP address</b>: Every device connected to the Internet is
            assigned a number known as an Internet protocol (IP) address. These
            numbers are usually assigned in geographic blocks. An IP address can
            often be used to identify the location from which a device is
            connecting to the Internet.
          </li>
          <li>
            <b>Personnel</b>: refers to those individuals who are employed by
            Invifo or are under contract to perform a service on behalf of one
            of the parties.
          </li>
          <li>
            <b>Personal Data</b>: any information that directly, indirectly, or
            in connection with other information — including a personal
            identification number — allows for the identification or
            identifiability of a natural person.
          </li>
          <li>
            <b>Service</b>: refers to the service provided by Invifo as
            described in the relative terms (if available) and on this platform.
          </li>
          <li>
            <b>Third-party service</b>: refers to advertisers, contest sponsors,
            promotional and marketing partners, and others who provide our
            content or whose products or services we think may interest you.
          </li>
          <li>
            <b>Website</b>: Invifo's site, which can be accessed via this URL:
            https://invifo.com.
          </li>
          <li>
            <b>You</b>: a person or entity that is registered with Invifo to use
            the Services.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Limited liability
      </Typography>
      <Typography paragraph variant="body1">
        We endeavour to update and/or supplement the content of our service on a
        regular basis. Despite our care and attention, content may be incomplete
        and/or incorrect.
      </Typography>
      <Typography paragraph variant="body1">
        The materials we offer are offered without any form of guarantee or
        claim to their correctness. These materials can be changed at any time
        without prior notice from us.
      </Typography>
      <Typography paragraph variant="body1">
        Particularly, all prices on our service are stated subject to typing and
        programming errors. No liability is assumed for the implications of such
        errors. No agreement is concluded on the basis of such errors.
      </Typography>
      <Typography paragraph variant="body1">
        We shall not bear any liability for hyperlinks to websites or services
        of third parties included on our service. From our service, you can
        visit other websites by following hyperlinks to such external sites.
        While we strive to provide only quality links to useful and ethical
        websites, we have no control over the content and nature of these sites.
        These links to other websites do not imply a recommendation for all the
        content found on these sites. Site owners and content may change without
        notice and may occur before we have the opportunity to remove a link
        which may have gone 'bad'.
      </Typography>
      <Typography paragraph variant="body1">
        Please be also aware that when you leave our service, other sites may
        have different privacy policies and terms which are beyond our control.
        Please be sure to check the Privacy Policies of these sites as well as
        their "Terms of Service" before engaging in any business or uploading
        any information.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Errors and Omissions Disclaimer
      </Typography>
      <Typography paragraph variant="body1">
        We are not responsible for any content, code or any other imprecision.
      </Typography>
      <Typography paragraph variant="body1">
        We do not provide warranties or guarantees.
      </Typography>
      <Typography paragraph variant="body1">
        In no event shall we be liable for any special, direct, indirect,
        consequential, or incidental damages or any damages whatsoever, whether
        in an action of contract, negligence or other tort, arising out of or in
        connection with the use of the Service or the contents of the Service.
        We reserve the right to make additions, deletions, or modifications to
        the contents on the Service at any time without prior notice.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Copyright Disclaimer
      </Typography>
      <Typography paragraph variant="body1">
        All intellectual property rights concerning these materials are vested
        in Invifo. Copying, distribution and any other use of these materials is
        not permitted without the written permission from Invifo, except and
        only to the extent otherwise provided in regulations of mandatory law
        (such as the right to quote), unless otherwise stated for certain
        materials.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        General Disclaimer
      </Typography>
      <Typography paragraph variant="body1">
        The Invifo Service and its contents are provided "as is" and "as
        available" without any warranty or representations of any kind, whether
        express or implied. Invifo is a distributor and not a publisher of the
        content supplied by third parties, as such, Invifo exercises no
        editorial control over such content and makes no warranty or
        representation as to the accuracy, reliability or currency of any
        information, content, service or merchandise provided through or
        accessible via the Invifo Service. Without limiting the foregoing,
        Invifo specifically disclaims all warranties and representations in any
        content transmitted on or in connection with the Invifo Service or on
        sites that may appear as links on the Invifo Service, or in the products
        provided as a part of, or otherwise in connection with, the Invifo
        Service, including without limitation any warranties of merchantability,
        fitness for a particular purpose or non-infringement of third party
        rights. No oral advice or written information given by Invifo or any of
        its affiliates, employees, officers, directors, agents, or the like will
        create a warranty. Price and availability information is subject to
        change without notice. Without limiting the foregoing, Invifo does not
        warrant that the Invifo Service will be uninterrupted, uncorrupted,
        timely, or error-free.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Affiliate Disclosure
      </Typography>
      <Typography paragraph variant="body1">
        Invifo has affiliate links and in this section of the Disclaimer we will
        address how we use those affiliate links from other websites/ companies
        and products. These "affiliate links" are specific URLs that contain the
        affiliate's ID or username.
      </Typography>
      <Typography paragraph variant="body1">
        In compliance with the FTC guidelines, please assume the following about
        links and posts on this site:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            Any/all of the links on Invifo are affiliate links of which we
            receive a small commission from sales of certain items, but the
            price is the same for you. As Invifo has grown, so have costs
            associated with running and maintaining it, and affiliate links are
            a way we help offset these costs.
          </li>
          <li>
            If we post an affiliate link to a product, it is something that we
            personally use, support and would recommend without an affiliate
            link.
          </li>
          <li>
            Unless otherwise noted, all reviews are of items we have purchased
            and we are not paid or compensated in any way.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        We might participate in affiliate programs such as:
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Testimonials Disclosure
      </Typography>
      <Typography paragraph variant="body1">
        Any testimonials provided on this platform are opinions of those
        providing them. The information provided in the testimonials is not to
        be relied upon to predict results in your specific situation. The
        results you experience will be dependent on many factors including but
        not limited to your level of personal responsibility, commitment, and
        abilities, in addition to those factors that you and/or us may not be
        able to anticipate.
      </Typography>
      <Typography paragraph variant="body1">
        We will give honest testimonials to our visitors regardless of any
        discount. Any product or service that we test are individual
        experiences, reflecting real life experiences. The testimonials could be
        displayed on audio, text or video and are not necessarily representative
        of all of those who will use our products and/or services.
      </Typography>
      <Typography paragraph variant="body1">
        Invifo does not guarantee the same results as the testimonials given on
        our platform. Testimonials presented on our platform are applicable to
        the individuals writing them, and may not be indicative of future
        success of any other individuals.
      </Typography>
      <Typography paragraph variant="body1">
        Please don't hesitate to contact us if you would like to know more about
        testimonials, discounts, or any of the products/services that we review.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Your Consent
      </Typography>
      <Typography paragraph variant="body1">
        We've updated our Disclaimer to provide you with complete transparency
        into what is being set when you visit our site and how it's being used.
        By using our service, registering an account, or making a purchase, you
        hereby consent to our Disclaimer and agree to its terms.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Changes To Our Disclaimer
      </Typography>
      <Typography paragraph variant="body1">
        Should we update, amend or make any changes to this document so that
        they accurately reflect our Service and policies. Unless otherwise
        required by law, those changes will be prominently posted here. Then, if
        you continue to use the Service, you will be bound by the updated
        Disclaimer. If you do not want to agree to this or any updated
        Disclaimer, you can delete your account.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Contact Us
      </Typography>
      <Typography paragraph variant="body1">
        Don't hesitate to contact us if you have any questions.
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>Via Email: support@invifo.com</li>
          <li>Via this Link: https://www.invifo.com/contact-us</li>
        </ul>
      </Typography>
    </React.Fragment>
  );
}

export default Disclaimer;
